module.exports = require('./helpers/bundle-url').getBundleURL('7VwIV') + "wac.92a80da2.svg";